import { HD, FULL_HD, RENDERING_CONTEXT } from '@bedrock-rdk/constants';
import { PRIMARY } from '@tornado-rdk/theme';
import { getElementSize } from '../utils/sizes';
import { ITEMS_BY_BREAKPOINTS } from './customer/default/flatRectangle.constants';

export * from './customer/default/flatRectangle.constants';

export const templates = {
  FlatRectangle: 'FlatRectangle',
};

const RATIO = 4 / 15;

const { sizes } = getElementSize(ITEMS_BY_BREAKPOINTS, RATIO, templates.FlatRectangle);

const buildImageOptions = context =>
  [HD, FULL_HD].reduce(
    (result, breakpoint) => ({
      ...result,
      [breakpoint]: {
        [PRIMARY]: {
          width: sizes[templates.FlatRectangle][context][breakpoint].w * 2,
          height: sizes[templates.FlatRectangle][context][breakpoint].h * 2,
        },
      },
    }),
    {},
  );

const imageOptions = {
  [templates.FlatRectangle]: {
    [RENDERING_CONTEXT.GENERAL]: buildImageOptions(RENDERING_CONTEXT.GENERAL),
    [RENDERING_CONTEXT.SEARCH]: buildImageOptions(RENDERING_CONTEXT.SEARCH),
  },
};

export { sizes, imageOptions };
